import { styled } from 'styled-system/jsx'

const InsightsCard = styled('div', {
  base: {
    width: '100%',
    backgroundColor: '#FFFFFF',
    borderRadius: 'lg',
    border: '1.5px solid',
    borderColor: '#F0EDFA',
    padding: '18px 20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '14px',
    boxShadow: '0 12px 32px -22px rgba(128, 84, 255, 0.18)',
  },
})

const PersonalityRow = styled('div', {
  base: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
  },
})

const PersonalityGlyph = styled('span', {
  base: {
    width: '40px',
    height: '40px',
    borderRadius: 'pill',
    backgroundColor: 'quickpass.surfaceCool',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '22px',
    flexShrink: '0',
  },
})

const PersonalityText = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0',
  },
})

const PersonalityLabel = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '15px',
    fontWeight: '700',
    color: 'quickpass.ink',
    letterSpacing: '-0.1px',
  },
})

const PersonalityHint = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: 'quickpass.inkSoft',
    fontStyle: 'italic',
  },
})

const StatsGrid = styled('div', {
  base: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))',
    gap: '14px',
    paddingTop: '14px',
    borderTop: '1px solid',
    borderColor: '#F0EDFA',
  },
})

const StatCell = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
})

const StatLabel = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '700',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
    color: 'quickpass.inkSoft',
  },
})

const StatValue = styled('span', {
  base: {
    fontFamily: 'display',
    fontSize: '20px',
    fontWeight: '800',
    color: 'quickpass.ink',
    letterSpacing: '-0.3px',
  },
  variants: {
    accent: {
      neutral: {},
      success: { color: 'quickpass.success' },
      primary: { color: 'quickpass.primary' },
    },
  },
  defaultVariants: {
    accent: 'neutral',
  },
})

const StatHint = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '11px',
    color: 'quickpass.inkSoft',
  },
})

export {
  InsightsCard,
  PersonalityRow,
  PersonalityGlyph,
  PersonalityText,
  PersonalityLabel,
  PersonalityHint,
  StatsGrid,
  StatCell,
  StatLabel,
  StatValue,
  StatHint,
}
